<script setup lang="ts">
import roRO from 'ant-design-vue/es/locale/ro_RO'
import { ereachTheme } from '@/plugins/antd-theme'
</script>

<template>
  <a-config-provider :theme="ereachTheme" :locale="roRO">
    <router-view />
  </a-config-provider>
</template>
